import React from 'react';
import Styles from './index.less';
import Checkbox from '@tencent/dui/esm/components/Checkbox';
import i18n from '@i18next/i18n';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

export interface ICheckboxPanelProps {
    firstRowChecked: boolean;
    lastRowChecked: boolean;
    firstColChecked: boolean;
    lastColChecked: boolean;
    bandRowChecked: boolean;
    bandColChecked: boolean;
    onFirstRowClick();
    onLastRowClick();
    onFirstColClick();
    onLastColClick();
    onBandRowClick();
    onBandColClick();
}
export class CheckboxPanel extends React.PureComponent<ICheckboxPanelProps> {
    public render() {
        return <div className={Styles['checkbox-panel-container']}>
            <div className={Styles['col-container']} style={{
                marginRight: 8,
            }}>
                <div className={Styles['upper-item-container']}>
                    <Tooltip title={i18n.t('标题行')}>
                        <Checkbox
                            checked={this.props.firstRowChecked}
                            onChange={this.props.onFirstRowClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('标题行')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
                <div className={Styles['lower-item-container']}>
                    <Tooltip title={i18n.t('汇总行')}>
                        <Checkbox
                            checked={this.props.lastRowChecked}
                            onChange={this.props.onLastRowClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('汇总行')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
            </div>
            <div className={Styles['col-container']} style={{
                marginRight: 8,
            }}>
                <div className={Styles['upper-item-container']}>
                    <Tooltip title={i18n.t('第一列')}>
                        <Checkbox
                            checked={this.props.firstColChecked}
                            onChange={this.props.onFirstColClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('第一列')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
                <div className={Styles['lower-item-container']}>
                    <Tooltip title={i18n.t('结尾列')}>
                        <Checkbox
                            checked={this.props.lastColChecked}
                            onChange={this.props.onLastColClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('结尾列')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
            </div>
            <div className={Styles['col-container']}>
                <div className={Styles['upper-item-container']}>
                    <Tooltip title={i18n.t('镶边行')}>
                        <Checkbox
                            checked={this.props.bandRowChecked}
                            onChange={this.props.onBandRowClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('镶边行')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
                <div className={Styles['lower-item-container']}>
                    <Tooltip title={i18n.t('镶边列')}>
                        <Checkbox
                            checked={this.props.bandColChecked}
                            onChange={this.props.onBandColClick}
                            className={Styles['checkbox-custom-style']}>
                            {
                                i18n.t('镶边列')
                            }
                        </Checkbox>
                    </Tooltip>
                </div>
            </div>
        </div>;
    }
}


